export default {
    apiUrl: 'https://digitalcards.calzedonia.com/graphql' //   http://localhost:3002/graphql
};